// accessibilityInit.ts
// Native buttons are already keyboard-focusable, so avoid document-wide startup
// scans. This shim only patches explicitly marked compatibility roots.

const BUTTON_ROOT_ATTR = "data-force-button-tabindex-root";
const BUTTON_ATTR = "data-force-tabindex";

function ensureTabindexOnMarkedRoot(root: ParentNode): void {
  try {
    root.querySelectorAll<HTMLButtonElement>(`button[${BUTTON_ATTR}]`).forEach((button) => {
      if (!button.hasAttribute("tabindex")) {
        button.setAttribute("tabindex", "0");
      }
    });
  } catch {
    // ignore compatibility best-effort work
  }
}

function patchMarkedNode(node: Node): void {
  if (!(node instanceof HTMLElement)) {
    return;
  }

  if (node.matches(`button[${BUTTON_ATTR}]`) && !node.hasAttribute("tabindex")) {
    node.setAttribute("tabindex", "0");
  }

  if (node.matches(`[${BUTTON_ROOT_ATTR}]`)) {
    ensureTabindexOnMarkedRoot(node);
  }

  node.querySelectorAll<HTMLElement>(`[${BUTTON_ROOT_ATTR}]`).forEach((root) => {
    ensureTabindexOnMarkedRoot(root);
  });
}

if (typeof window !== "undefined" && typeof document !== "undefined") {
  try {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of Array.from(mutation.addedNodes)) {
          patchMarkedNode(node);
        }
      }
    });

    observer.observe(document.documentElement || document.body, {
      childList: true,
      subtree: true,
    });
  } catch {
    // ignore
  }
}

export {};
